import {
  I18N_MAPPING,
  TOTP_PROVIDER_AMPLITUDE_EVENT
} from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { createWrapper } from '../../utils/react-utils';
import { Button } from '@athena/forge';
import React from 'react';
import BaseForgeCustomizer from '../base-forge';
import { getLocalizedString } from '../../utils/i18n-utils';

export default class ActivateTotpCutomizer extends BaseForgeCustomizer {
  displayFooterText = true;
  headerText = getLocalizedString('totp.enroll.step.2.header.text');
  headerDescription = getLocalizedString('totp.enroll.step.2.header.description');

  primaryButtonOnClick = () => {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT[this.provider]}TotpActivatePush::VerifyButtonClick`);
  };

  async shouldCustomize() {
    return [ 'activate-totp' ].includes(this.context.controller);
  }

  async forgifyController() {
    super.forgifyController();
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT[this.provider]}TotpActivatePush::Landing`);
    this.addGoBackFooterButton();
  }

  addGoBackFooterButton() {
    const athenaFooter = jQueryCourage('#athena-footer');
    if (athenaFooter.length > 0) {
      const goBackButtonContainer = createWrapper({ hidden: false });
      athenaFooter.after(goBackButtonContainer);
      const component = (
        <Button
          variant="tertiary"
          size="small"
          fullWidth={false}
          text={I18N_MAPPING['en']['oform.back']}
          onClick={async () => {
            const isManualTotpSetup = this.oktaSignIn.router.appState.get('isManualTotpSetup');
            if (isManualTotpSetup) {
              const activatedFactorProvider = this.oktaSignIn.router.appState.get('activatedFactorProvider');
              const activatedFactorType = this.oktaSignIn.router.appState.get('activatedFactorType');
              const manualSetupTotpRoute = `signin/enroll-activate/${activatedFactorProvider}/${activatedFactorType}/manual`;
              this.oktaSignIn.router.appState.trigger('navigate', manualSetupTotpRoute);
            }
            else {
              this.oktaSignIn.router.controller.model.startTransaction(function (authClient: any) {
                return authClient.tx.resume();
              });
            }
          }}
        />
      );
      this.renderReactComponent({
        id: 'activate-totp-go-back-link',
        component,
        container: goBackButtonContainer,
      });
    }
  }
}
